<template>
  <a-drawer
      :visible="visible"
      class="custom-class"
      :title="title"
      placement="right"
      width="60%"
      @close="handleCancel"
  >
    <p>
      <router-link
          :to="{
                  name: 'authorList',
                }"
          target="_blank"
      >请先建立播主公共分组
      </router-link>
      再从中选择关联到项目中，以按需锁定项目统计的媒体号范围。
    </p>
    <a-row class="content">
      <a-col>
        <div class="select-box">
          <a-input
              placeholder="请输入"
              allow-clear
              v-model="searchText"
          />
          <base-button
              :type="'primary'"
              :title="'刷新分组列表'"
              @onClickBtn="updataGroupList"
              style="margin-left: 10px"
          >
          </base-button>
        </div>
        <div class="checkbox-box">
          <a-spin v-if="loading" size="large" tip="加载中..." style="padding: 24px"/>
          <a-row
              style="padding: 8px 0"
              v-for="(item, index) in groupList"
              :key="index">
            <a-col :span="24">
              <a-checkbox
                  :value="item.id"
                  :checked="(authorIds || []).some(v => v.authorGroupId == item.id)"
                  @change="onChangeGroup(item)"
              >
                {{ item.name }}
              </a-checkbox>
            </a-col>
          </a-row>
          <!--</a-checkbox-group>-->
        </div>
      </a-col>
    </a-row>
    <template solt="footer">
      <div class="flex-end">
        <base-button
            :title="'取消'"
            @onClickBtn="handleCancel"
            style="margin-right: 20px"
        >
        </base-button>
        <base-button
            :type="'primary'"
            :title="'保存'"
            :loading="is_submit"
            :disabled="is_submit"
            @onClickBtn="handleSubmit"
        >
        </base-button>
      </div>
    </template>
  </a-drawer>
</template>

<script>
import _API from "@/api/projectManagement";
import authorApi from "@/api/author";

const debounce = (function() {
  let timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

import { createNamespacedHelpers } from "vuex";

const {mapGetters} = createNamespacedHelpers("temporary_parameters");
export default {
  name: "createGroupDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "添加播主分组到项目",
    },
    projectId: {
      type: [String, Number],
    },
  },
  watch: {
    searchText: {
      handler: function(value) {
        debounce(() => {
          this.getGroupList();
        }, 500);
      },
    },
  },
  data() {
    return {
      groupList: [],
      authorIds: [],
      is_submit: false,
      loading: false,
      searchText: "",
    };
  },
  mounted() {
    // this.getGroupList();
  },
  computed: {
    ...mapGetters(["getTemporaryParameters"]),
  },
  methods: {
    getGroupList() {
      this.loading = true;
      authorApi.fetchAuthorPublicGroupList({name: this.searchText || "", page: 1, size: 200}).then((res) => {
        this.loading = false;
        if(res.code == 200) {
          this.groupList = res.data.list || [];
        } else {
          this.$message.error(res.message || "获取经销商分组失败");
        }
      });
    },
    updataGroupList() {
      this.searchText = "";
      this.getGroupList();
    },
    onChangeGroup(value) {
      const {id, name} = value;
      if(this.authorIds.some(v => v.authorGroupId == id)) {
        this.authorIds = this.authorIds.filter(v => v.authorGroupId !== id);
        return;
      }

      const obj = {authorGroupId: id, authorGroupName: name};
      this.authorIds.push(obj);
    },
    removeGroup(index) {
      this.authorIds.splice(index, 1);
    },
    handleCancel() {
      this.$emit("handleCancel");
      this.authorIds = [];
      this.groupList = [];
      this.searchText = "";
    },
    handleSubmit() {
      if(this.authorIds.length) {
        this.saveAuthor(this.authorIds);
      } else {
        this.$message.error("请选择分组");
      }
    },
    saveAuthor(data) {
      this.is_submit = true;
      let params = {
        groups: data,
        kpiBusinessId: this.getTemporaryParameters.kpiBusinessId
      };
      _API.saveAuthor(params).then((res) => {
        if(res.code == 200) {
          this.$message.success("保存成功");
          this.handleCancel();
        } else {
          this.$message.error(res.message || "保存失败");
        }
        this.is_submit = false;
      });
    },
  },
};
</script>

<style scoped lang="less">
.select-box {
  display: flex;
  align-items: center;
}

.line {
  width: 1px;
  background: #c2c2c2;
  height: calc(100vh - 300px);
  margin: 0 8px;
}

.content {
  height: calc(100vh - 300px);
  overflow-y: auto;
}

.groupName {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px 0;
  padding: 40px 0 20px 20%;
  border-top: 1px solid #cccccc
}

.checkbox-box {
  padding: 15px;
  height: calc(100vh - 300px);
  overflow-y: auto;
}
</style>
